import * as React from 'react';
export const BYSvg = React.forwardRef(function BYSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement(
      'g',
      {
        fill: 'none',
        fillRule: 'evenodd',
      },
      /*#__PURE__*/ React.createElement(
        'g',
        null,
        /*#__PURE__*/ React.createElement('path', {
          fill: '#F6F9FC',
          d: 'M1.998 2A2.005 2.005 0 0 0 0 4.009v7.982C0 13.101.898 14 1.998 14H6V2H1.998Z',
        }),
        /*#__PURE__*/ React.createElement('path', {
          fill: '#EAEEF3',
          fillRule: 'nonzero',
          d: 'M2 2a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h4v-1H2a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h4V2H2Z',
        }),
        /*#__PURE__*/ React.createElement('path', {
          fill: '#E25950',
          d: 'M14.14 2C15.167 2 16 3.02 16 4.276V8H6V2h8.14Z',
        }),
        /*#__PURE__*/ React.createElement('path', {
          fill: '#24B47E',
          d: 'M16 12.257c0 .961-.832 1.743-1.86 1.743H6V8h10v4.257Z',
        }),
      ),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#E25950',
        fillRule: 'nonzero',
        d: 'M1.776 4.447a.5.5 0 0 1 0-.894l2-1a.5.5 0 0 1 .448.894L3.118 4l1.106.553a.5.5 0 0 1 0 .894L3.118 6l1.106.553a.5.5 0 0 1 0 .894L3.118 8l1.106.553a.5.5 0 0 1 0 .894L3.118 10l1.106.553a.5.5 0 0 1 0 .894L3.118 12l1.106.553a.5.5 0 1 1-.448.894l-2-1a.5.5 0 0 1 0-.894L2.882 11l-1.106-.553a.5.5 0 0 1 0-.894L2.882 9l-1.106-.553a.5.5 0 0 1 0-.894L2.882 7l-1.106-.553a.5.5 0 0 1 0-.894L2.882 5l-1.106-.553Z',
      }),
    ),
  );
});
BYSvg.defaultProps = {
  xmlns: 'http://www.w3.org/2000/svg',
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
};
export var BY = {
  category: 'flag',
  colorable: false,
  name: 'BY',
  svg: BYSvg,
};
